import React from 'react';
import buildInfo from '../generated/buildInfo.json';

function HiddenVersion() {
  const localBuildTime = buildInfo.buildTimeIso && buildInfo.buildTimeIso !== '1970-01-01T00:00:00.000Z'
    ? new Date(buildInfo.buildTimeIso).toLocaleString()
    : 'Not generated yet';

  return (
    <main style={{ minHeight: '100dvh', background: '#0a0a0a', color: '#f8fafc', padding: '80px 20px' }}>
      <div style={{ maxWidth: 780, margin: '0 auto', border: '1px solid rgba(255,255,255,0.12)', borderRadius: 12, padding: 24, background: 'rgba(0, 0, 0, 0.7)' }}>
        <h1 style={{ marginTop: 0, marginBottom: 18, fontSize: '1.6rem' }}>Deployment Version</h1>
        <p style={{ opacity: 0.8, marginTop: 0, marginBottom: 18 }}>
          Hidden diagnostics page for current deployed build.
        </p>
        <div style={{ display: 'grid', gridTemplateColumns: '180px 1fr', gap: 10 }}>
          <strong>App</strong><span>{buildInfo.appName}</span>
          <strong>Version</strong><span>{buildInfo.appVersion}</span>
          <strong>Build ID</strong><span>{buildInfo.buildId}</span>
          <strong>Build Time</strong><span>{localBuildTime}</span>
          <strong>Commit</strong><span>{buildInfo.commitSha}</span>
          <strong>Source</strong><span>{buildInfo.source}</span>
        </div>
      </div>
    </main>
  );
}

export default HiddenVersion;
